import { useContext, useEffect, useState } from 'react'
import {
  MemoContext,
  SELECT_DTC_MEMO,
  SET_UPDATED_DTC_MEMO,
  SHOW_DTC_MEMO_POPUP,
} from '../context/context'
import Modal, { ModalBody, ModalHeader } from '../../../common/Modal'
import SelectInput from '../../../common/SelectInput'
import InputText from '../../../common/InputText'
import TextArea from '../../../common/TextArea'
import Button from '../../../common/Button'
import useDebouncedValue from '../../../../utils/common_function'
import { useParams } from 'react-router-dom'
import { getRequest, postRequest, putRequest } from '../../../../services/base'
import { NavContext } from '../../../../context/global_context'

const DtcMemoFormPopup = (props) => {
  let { vehicle } = useParams()

  const [state, dispatch] = useContext(MemoContext)
  const [navState, navDispatch] = useContext(NavContext)

  const [options, setOptions] = useState([])
  const [searchDtc, setSearchDtc] = useState('')
  const debouncedSearchTerm = useDebouncedValue(searchDtc, 1000)

  useEffect(() => {
    getDtcsData('')
  }, [])

  useEffect(() => {
    getDtcsData(debouncedSearchTerm)
  }, [debouncedSearchTerm])

  const getDtcsData = async (search = '') => {
    if (!state?.selected_memo?.id) {
      let res = await getRequest(
        `/api/dtcs/?vehicle=${vehicle}&search=${search}&limit=5`
      )
      setOptions(res.results)
    }
  }

  const dtcFilterOptions = (option, searchText) => {
    if (
      option.data.name.toLowerCase().includes(searchText.toLowerCase()) ||
      option.data.description
        .toLowerCase()
        .includes(searchText.toLowerCase()) ||
      option.data.ecu.toLowerCase().includes(searchText.toLowerCase())
    ) {
      return true
    } else {
      return false
    }
  }

  const closeMemoCreatePopup = () => {
    dispatch({
      type: SELECT_DTC_MEMO,
      data: { selected_memo: {}, show_memo_popup: false },
    })
  }

  const saveDTCMemos = async (e) => {
    const formData = new FormData(e.target)
    formData.append('vehicle', vehicle)
    let res = null
    if (state?.selected_memo?.id) {
      res = await putRequest(
        `/api/dtc_memos/${state?.selected_memo?.id}/?vehicle=${vehicle}`,
        formData
      )
      if (res?.status) {
        dispatch({
          type: SET_UPDATED_DTC_MEMO,
          data: { ...res.data, index: state?.selected_memo?.index },
        })
        navDispatch({
          type: 'notification',
          data: {
            notification_type: 'success',
            msg: 'DTC Memos Successfully saved',
          },
        })
        closeMemoCreatePopup()
      } else {
        navDispatch({
          type: 'notification',
          data: {
            notification_type: 'error',
            msg: 'Something went wrong.',
          },
        })
      }
    } else {
      res = await postRequest(`/api/dtc_memos/?vehicle=${vehicle}`, formData)
      props.getListData()
      closeMemoCreatePopup()
      navDispatch({
        type: 'notification',
        data: {
          notification_type: 'success',
          msg: 'DTC Memos Successfully saved',
        },
      })
    }
  }

  return (
    <Modal
      onClose={() => {
        dispatch({
          type: SELECT_DTC_MEMO,
          data: { selected_memo: {}, show_memo_popup: false },
        })
      }}
      show={state.show_memo_popup}
    >
      <ModalHeader className={'text-white'}>DTC Memos</ModalHeader>
      <ModalBody>
        <div className="container">
          <form
            onSubmit={(e) => {
              e.preventDefault()
              saveDTCMemos(e)
            }}
          >
            <input
              type="hidden"
              value={state?.selected_memo?.id ? false : true}
              name="is_create"
            />
            <input type="hidden" name="import_file" value={null} />
            {state?.selected_memo?.id && (
              <input type="hidden" name="id" value={state?.selected_memo?.id} />
            )}

            <div
              className={`flex justify-between ${state?.selected_memo?.id && 'disabled'}`}
            >
              <SelectInput
                value={
                  state?.selected_memo.dtc_obj?.id
                    ? state?.selected_memo.dtc_obj
                    : null
                }
                onInputChange={(value) => {
                  setSearchDtc(value)
                }}
                formatOptionLabel={(option) => (
                  <>
                    <div className="font-extrabold">
                      {option.name} ({option.ecu})
                    </div>
                    <div>
                      <span>{option.description}</span>
                    </div>
                  </>
                )}
                optionLabel={'name'}
                optionValue={'id'}
                filterOption={dtcFilterOptions}
                name="dtc"
                options={options}
                label={`DTC`}
                onChange={(obj) => {
                  dispatch({
                    type: SELECT_DTC_MEMO,
                    data: {
                      selected_memo: { ...state?.selected_memo, dtc_obj: obj },
                      show_memo_popup: true,
                    },
                  })
                }}
                isRequired={true}
              />
            </div>
            <div className="flex justify-between w-full">
              <div className="w-6/12">
                <TextArea
                  label={`Memo`}
                  name="memo"
                  value={
                    state?.selected_memo?.memo
                      ? state?.selected_memo?.memo
                      : null
                  }
                  isRequired={false}
                  className={'w-full'}
                  onChange={() => {}}
                />
              </div>
              <div className="w-6/12">
                <InputText
                  label={`Short Description`}
                  name="short_desc"
                  value={
                    state?.selected_memo?.short_desc
                      ? state?.selected_memo?.short_desc
                      : null
                  }
                  isRequired={false}
                  type="text"
                  readOnly={state?.selected_memo?.id ? true : false}
                  maxLength={128}
                />
              </div>
            </div>
            <div className="flex justify-end py-4">
              <Button
                type="submit"
                className={`cursor-pointer btn w-1/3 justify-end pr-2`}
                onClick={(e) => {}}
                value={'text'}
                text={'Save DTC Memos'}
              />
            </div>
          </form>
        </div>
      </ModalBody>
    </Modal>
  )
}

export default DtcMemoFormPopup
